module.exports = __webpack_public_path__ + "img/马勃.d4fc264b.jpg";